export const WELCOME_STEP_ID = 'Welcome';
export const LICENSE_STEP_ID = 'license';
export const GENERAL_STEP_ID = 'general';
export const PROTECTED_DOMAIN_STEP_ID = 'protectedDomains';
export const SF_NODES_STEP_ID = 'silverfortNodes';
export const AVAILABILITY_ZONES_STEP_ID = 'availabilityZones';
export const MID_FINISH_STEP_ID = 'midFinish';
export const MFA_TOKENS_STEP_ID = 'mfaTokens';
export const DESKTOP_APP_STEP_ID = 'desktopApplication';
export const INTEGRATIONS_STEP_ID = 'integrations';
export const FINISH_STEP_ID = 'finish';
